import './modal.style.scss';

export { default } from './modal';
